export default __webpack_public_path__ + "static/media/icfearsheraldwithstickkind.44d6dd9b.png";